import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";

interface InviteTeamMemberParams {
  email: string;
  roleId: number;
}

export const useTeamInvite = () => {
  const queryClient = useQueryClient();

  return useMutation<unknown, Error, InviteTeamMemberParams>({
    mutationFn: async ({ email, roleId }) => {
      const response = await httpService.post(API_CONFIG.path.teamMembers, {
        email,
        role_id: roleId,
      });
      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["team-members"] });
    },
  });
};
